module.exports = "<app-inventory-manager [inventoryManagerType]=\"'SS'\"></app-inventory-manager>"